import { compact, values } from 'lodash';
import { ORDER_TYPES, ORDER_TYPES_LABELS_DISPLAY_ALIAS } from '@nandosaus/constants';
import { PropTypes } from 'prop-types';
import React from 'react';

import { Alert } from '../../alert';
import { Box } from '../../grid';
import { InputList } from '../../input-list';
import { P } from '../../typography/new';
import { useFeature } from '../../../hooks/use-feature';

// Catering's fulfilment selector: Pick up vs Delivery. The Delivery tile (catering
// delivery) is gated entirely by the `catering-delivery-enabled` flag — when off, the
// catering modal behaves exactly as it does today (pickup only).
const OrderTypePicker = ({ errorMessage, orderType, availableOrderTypes, onSelect }) => {
  const cateringDeliveryEnabled = useFeature('catering-delivery-enabled');

  const orderTypes = compact([
    {
      label: ORDER_TYPES_LABELS_DISPLAY_ALIAS[ORDER_TYPES.CATERING],
      value: ORDER_TYPES.CATERING,
      icon: 'shoppingBagChili',
      disabled: false,
    },
    cateringDeliveryEnabled
      ? {
          label: ORDER_TYPES_LABELS_DISPLAY_ALIAS[ORDER_TYPES.CATERING_DELIVERY],
          value: ORDER_TYPES.CATERING_DELIVERY,
          icon: 'delivery',
          disabled: false,
        }
      : null,
    {
      label: 'Dine in',
      value: ORDER_TYPES.DINE_IN,
      icon: 'cutlery',
      disabled: true,
    },
  ]).map(option => {
    const disabled = !availableOrderTypes.includes(option.value) || option.disabled;
    return { ...option, disabled };
  });

  return (
    <Box mb="30px">
      <P mb="8px" variant="small-semi-bold">
        Order Type
      </P>
      <InputList items={orderTypes} selectedItems={[orderType]} onSelect={onSelect} type="tile" />
      {errorMessage !== undefined && (
        <Box mt="12px">
          <Alert type="error">{errorMessage}</Alert>
        </Box>
      )}
    </Box>
  );
};

OrderTypePicker.propTypes = {
  errorMessage: PropTypes.string,
  orderType: PropTypes.oneOf(values(ORDER_TYPES)),
  availableOrderTypes: PropTypes.arrayOf(PropTypes.oneOf(values(ORDER_TYPES))),
  onSelect: PropTypes.func,
};

OrderTypePicker.defaultProps = {
  errorMessage: undefined,
  orderType: undefined,
  availableOrderTypes: [],
  onSelect: () => {},
};

export { OrderTypePicker };
